import type { ButtonProps, ButtonVariants } from "@qws-org/ui-kit";
import { Button } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, HeaderSdk, Pages } from "~/core";
import {
  isExternalLink,
  isInternalLink,
  isTemplateUrl,
} from "~/core/utils/action.utils";

export type MobileMenuButtonProps = {
  item: NonNullable<
    ExtractArrayItemType<
      NonNullable<
        NonNullable<NonNullable<HeaderSdk>["additional_menu"]>["action_items"]
      >
    >
  >["menu_action_items_id"];
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  variant?: ButtonVariants;
} & ButtonProps<"button">;

export const MobileMenuButton: FC<MobileMenuButtonProps> = ({
  item,
  getUrl,
  onCallAction,
  variant = "transparent",
  ...props
}) => {
  const controlAction = item?.action;
  const action = controlAction?.action?.[0];
  let href: string | undefined;

  if (isExternalLink(action?.item)) {
    if (isTemplateUrl(action?.item)) {
      href = undefined;
    } else {
      href = action.item.href ?? undefined;
    }
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }

  return (
    <Button
      {...props}
      p={{ py: 12 }}
      md={{
        display: item?.action?.inactive_if?.includes("isMobile")
          ? "block"
          : item?.action?.inactive_if?.includes("isDesktop")
            ? "hidden"
            : undefined,
      }}
      href={href}
      display={
        item?.action?.inactive_if?.includes("isMobile")
          ? "block"
          : item?.action?.inactive_if?.includes("isDesktop")
            ? "hidden"
            : undefined
      }
      width="100%"
      className={props.className ?? ""}
      variant={variant}
      whiteSpace="nowrap"
      onPress={() => {
        if (controlAction) {
          onCallAction(controlAction);
        }
      }}
      size="small"
      weight="semibold"
      horizontalAlign="center"
    >
      {item?.translations?.[0]?.name}
    </Button>
  );
};
